import { createBlock, createRow } from "./defaultEmailDoc";

function p(text, marks = null) {
  const node = { type: "paragraph", content: [{ type: "text", text: String(text || "") }] };
  if (Array.isArray(marks) && marks.length) {
    node.content[0].marks = marks;
  }
  return node;
}

function textStyle(attrs) {
  return { type: "textStyle", attrs: { ...(attrs || {}) } };
}

function doc(...paragraphs) {
  return { type: "doc", content: paragraphs.filter(Boolean) };
}

export const EMAIL_SECTIONS = [
  {
    key: "hero_center",
    title: "Título e subtítulo",
    // Opcional: URL de miniatura para o preview na barra "Adicionar".
    // previewImage: "https://...",
    build() {
      const row = createRow({
        kind: "section",
        preset: "hero_center",
        columns: 1,
        settings: { paddingTop: 24, paddingBottom: 24 },
      });

      row.columns[0].blocks.push(
        createBlock("text", {
          align: "center",
          content: {
            tiptapJson: {
              ...doc(
                p("Título do email", [textStyle({ fontSize: "32px", })]),
                p("Uma descrição curta para contextualizar."),
              ),
            },
          },
        }),
      );

      row.columns[0].blocks.push(
        createBlock("button", {
          text: "Chamada para ação",
          href: "https://example.com",
          align: "center",
          borderRadius: 8,
          paddingX: 18,
          paddingY: 12,
        }),
      );

      return row;
    },
  },
  {
    key: "image_text",
    title: "Imagem + Texto",
    // Opcional: URL de miniatura para o preview na barra "Adicionar".
    // previewImage: "https://...",
    build() {
      const row = createRow({
        kind: "section",
        preset: "image_text",
        columns: 2,
        settings: { paddingTop: 16, paddingBottom: 16, columnGap: 20, columnWeights: [1, 1] },
      });

      row.columns[0].blocks.push(
        createBlock("image", {
          src: "",
          alt: "Imagem",
          href: "",
          align: "center",
          maxWidth: 260,
        }),
      );
      row.columns[1].blocks.push(
        createBlock("text", {
          align: "left",
          content: {
            tiptapJson: {
              ...doc(
                p("Título", [textStyle({ fontSize: "24px"})]),
                p("Descreva a oferta, notícia ou produto aqui."),
              ),
            },
          },
        }),
      );

      return row;
    },
  },
  {
    key: "text_image",
    title: "Texto + Imagem",
    build() {
      const row = createRow({
        kind: "section",
        preset: "text_image",
        columns: 2,
        settings: { paddingTop: 16, paddingBottom: 16, columnGap: 20, columnWeights: [2, 1] },
      });

      row.columns[0].blocks.push(
        createBlock("text", {
          align: "left",
          content: {
            tiptapJson: {
              ...doc(
                p("Título", [textStyle({ fontSize: "24px"})]),
                p("Conte a história, benefício ou destaque principal com um texto curto e direto."),
              ),
            },
          },
        }),
      );
      row.columns[0].blocks.push(
        createBlock("button", {
          text: "Saiba mais",
          href: "https://example.com",
          align: "left",
          borderRadius: 8,
          paddingX: 16,
          paddingY: 10,
        }),
      );

      row.columns[1].blocks.push(
        createBlock("image", {
          src: "",
          alt: "Imagem",
          href: "",
          align: "center",
          maxWidth: 220,
        }),
      );

      return row;
    },
  },
  {
    key: "features_3",
    title: "3 destaques",
    build() {
      const row = createRow({
        kind: "section",
        preset: "features_3",
        columns: 3,
        settings: { paddingTop: 16, paddingBottom: 16, columnGap: 16, columnWeights: [1, 1, 1] },
      });

      const feature = (title) =>
        createBlock("text", {
          align: "left",
          content: {
            tiptapJson: {
              ...doc(
                p(title, [textStyle({ fontSize: "16px"})]),
                p("Breve descrição do benefício em 1–2 linhas."),
              ),
            },
          },
        });

      row.columns[0].blocks.push(feature("Destaque 1"));
      row.columns[1].blocks.push(feature("Destaque 2"));
      row.columns[2].blocks.push(feature("Destaque 3"));

      return row;
    },
  },
  {
    key: "product_2",
    title: "2 produtos (cards)",
    build() {
      const row = createRow({
        kind: "section",
        preset: "product_2",
        columns: 2,
        settings: { paddingTop: 16, paddingBottom: 16, columnGap: 16, columnWeights: [1, 1] },
      });

      const productCard = () => ([
        createBlock("image", { src: "", alt: "Produto", href: "", align: "center", maxWidth: 260 }),
        createBlock("text", {
          align: "left",
          content: {
            tiptapJson: {
              ...doc(
                p("Produto", [textStyle({ fontSize: "18px"})]),
                p("Descrição curta do produto e um detalhe de valor."),
              ),
            },
          },
        }),
        createBlock("button", {
          text: "Comprar",
          href: "https://example.com",
          align: "left",
          borderRadius: 8,
          paddingX: 16,
          paddingY: 10,
        }),
      ]);

      row.columns[0].blocks.push(...productCard());
      row.columns[1].blocks.push(...productCard());
      return row;
    },
  },
  {
    key: "social_icons_3",
    title: "Ícones sociais (3)",
    build() {
      const row = createRow({
        kind: "section",
        preset: "social_icons_3",
        columns: 1,
        settings: {
          paddingTop: 12,
          paddingBottom: 12,
          align: "center",
        },
      });

      const icon = (alt) =>
        createBlock("image", {
          src: "",
          alt,
          href: "",
          align: "center",
          display: "inline",
          widthPx: 35,
          borderRadius: 9999,
          borderWidth: 1,
          borderColor: "#e5e7eb",
          objectFit: "cover",
          aspectRatio: "1 / 1",
          marginTop: 0,
          marginBottom: 0,
          marginLeft: 6,
          marginRight: 6,
        });

      row.columns[0].blocks.push(icon("Instagram"));
      row.columns[0].blocks.push(icon("WhatsApp"));
      row.columns[0].blocks.push(icon("Website"));
      return row;
    },
  },
  {
    key: "quote",
    title: "Depoimento",
    build() {
      const row = createRow({
        kind: "section",
        preset: "quote",
        columns: 1,
        settings: { paddingTop: 16, paddingBottom: 16 },
      });

      row.columns[0].blocks.push(
        createBlock("text", {
          align: "left",
          content: {
            tiptapJson: {
              ...doc(
                p("“Este produto mudou minha rotina — recomendo muito!”", [textStyle({ fontSize: "18px"})]),
                p("— Nome do cliente", [textStyle({ fontSize: "14px" })]),
              ),
            },
          },
        }),
      );

      return row;
    },
  },
  {
    key: "image_divider",
    title: "Divisor com imagem",
    build() {
      const row = createRow({
        kind: "section",
        preset: "image_divider",
        columns: 1,
        settings: {
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          columnGap: 0,
        },
      });

      row.columns[0].blocks.push(
        createBlock("image", {
          src: "",
          alt: "Imagem",
          href: "",
          align: "center",
          borderRadius: 0,
          objectFit: "cover",
          aspectRatio: "auto",
        }),
      );

      return row;
    },
  },
  {
    key: "divider",
    title: "Divisor",
    // Opcional: URL de miniatura para o preview na barra "Adicionar".
    // previewImage: "https://...",
    build() {
      const row = createRow({
        kind: "section",
        preset: "divider",
        columns: 1,
        settings: { paddingTop: 8, paddingBottom: 8 },
      });
      row.columns[0].blocks.push(createBlock("divider", { color: "#e5e7eb", thickness: 1 }));
      return row;
    },
  },
  {
    key: "footer_simple",
    title: "Rodapé simples",
    build() {
      const row = createRow({
        kind: "section",
        preset: "footer_simple",
        columns: 1,
        settings: { paddingTop: 16, paddingBottom: 24 },
      });

      row.columns[0].blocks.push(createBlock("divider", { color: "#e5e7eb", thickness: 1 }));
      row.columns[0].blocks.push(
        createBlock("text", {
          align: "center",
          content: {
            tiptapJson: {
              ...doc(
                p("Você recebeu este e-mail porque está inscrito.", [textStyle({ fontSize: "12px"})]),
                p("Cancelar inscrição", [textStyle({ fontSize: "12px", color: "#0ea5e9" })]),
              ),
            },
          },
        }),
      );

      return row;
    },
  },
];


